import React from 'react';
import { Link } from 'react-router-dom';
import { portfolio } from '../data/portfolio';
import SectionHeading from '../components/SectionHeading';
import Reveal from '../components/Reveal';
import SafeImage from '../components/SafeImage';
import Icon from '../components/Icon';

export default function Portfolio() {
  return (
    <section id="portfolio" className="section">
      <div className="container">
        <SectionHeading row title="Portfolio" text="Explore our portfolio showcasing successful projects with leading clients, where innovative solutions meet measurable results, proven expertise and lasting impact across industries. (Demo content.)" />
        <Reveal className="filters">
          <span className="filters__pill is-on">Projects</span>
          <span className="filters__pill">Products</span>
        </Reveal>
        <div className="pgrid pgrid--home">
          {portfolio.slice(0, 3).map((p, i) => (
            <Reveal key={p.name} delay={(i % 2) * 80}>
              <Link to="/portfolio" className="pcard pcard--home">
                <SafeImage src={p.image} alt={p.name} seed={i} />
                <div className="pcard__over">
                  <span>{p.category}</span>
                  <h3>{p.name}</h3>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
        <Reveal className="more">
          <Link className="btn btn--more" to="/portfolio">More <Icon name="arrow" size={18} /></Link>
        </Reveal>
      </div>
    </section>
  );
}
